<!--
 * @Author:
 * @LastEditTime: 2022-04-28 16:32:23
 * @Description:
-->
<template>
  <el-card class="h-full">
    <div class="flex mb-20px">
      <el-input
        size="mini"
        class="!w-280px mr-10px"
        placeholder="请输入关键字"
        clearable
        v-model="keyWord"
      />
      <el-button size="small" class="ml-0px mr-10px " type="primary" @click="searchList()"
        >搜索</el-button
      >
      <el-button size="small" class="!ml-0px mr-10px " type="primary" @click="createIdentity()"
        >新增</el-button
      >
    </div>
    <el-table
      stripe
      :height="tableHeight"
      ref="eltable"
      border
      :data="tableData"
      @sort-change="sortChangeTable"
    >
      <el-table-column label="名称" prop="name" sortable></el-table-column>
      <el-table-column label="显示名称" prop="displayName" sortable></el-table-column>
      <el-table-column label="必须" prop="required" sortable>
        <template slot-scope="scope">
          {{ scope.row.required ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="在发现文档中显示" prop="showInDiscoveryDocument" sortable>
        <template slot-scope="scope">
          {{ scope.row.showInDiscoveryDocument ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column label="启用" prop="enabled" sortable>
        <template slot-scope="scope">
          {{ scope.row.enabled ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column width="140" show-overflow-tooltip label="操作">
        <template slot-scope="scope">
          <el-button @click="editIdentity(scope.row)" size="mini">修改</el-button>
          <el-button size="mini" @click="deleteIdentity(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right mt-20px"
      background
      @size-change="searchList()"
      @current-change="findList()"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :total="page.pageTotal"
      layout="sizes, total, prev, pager, next, jumper"
      :pager-count="5"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
    >
    </el-pagination>
    <operate-identity-dialog
      v-if="showOperateIdentity"
      :operateIdentityProps="operateIdentityProps"
      :identityForm="identityForm"
      @refreshList="findList"
    ></operate-identity-dialog>
  </el-card>
</template>

<script>
import { IdentityResourceApi } from '@wiz-api/auth-server'

const identityResourceApi = new IdentityResourceApi()

const OperateIdentityDialog = () => {
  return import('../components/identity/OperateIdentityDialog')
}
export default {
  name: 'client',
  components: {
    OperateIdentityDialog,
  },
  data() {
    return {
      keyWord: '',
      showOperateIdentity: false,
      operateIdentityProps: {
        title: '新增身份资源',
        editType: 'create',
        visible: true,
      },
      identityForm: {
        name: '',
        displayName: '',
        userClaims: [],
        description: '',
        enabled: true,
        showInDiscoveryDocument: true,
      },
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      sort: {
        type: '',
        sortName: 'creationTime',
      },
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
  },
  methods: {
    sortChangeTable(sortColumn) {
      if (_.isNil(sortColumn.column)) {
        return
      }
      this.sort.type = sortColumn.order === 'ascending' ? 0 : 1
      this.sort.sortName = sortColumn.prop
      this.findList()
    },
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      const [err, res] = await identityResourceApi.getList({
        filter: this.keyWord,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        sorting: `${this.sort.sortName} ${this.sort.type === 0 ? 'asc' : 'desc'}`,
      })
      if (!err) {
        this.tableData = res.items
        this.page.pageTotal = res.totalCount
      }
    },
    createIdentity() {
      this.showOperateIdentity = true
      this.operateIdentityProps = this.$options.data().operateIdentityProps
      this.identityForm = this.$options.data().identityForm
    },
    async editIdentity(row) {
      const [err, res] = await identityResourceApi.get(row.id)
      if (!err) {
        this.identityForm = res
      }

      this.showOperateIdentity = true
      this.operateIdentityProps = this.$options.data().operateIdentityProps
      this.operateIdentityProps.editType = 'edit'
      this.operateIdentityProps.title = '编辑身份资源'
    },
    /**
     * @description: 删除身份
     * @param {*}
     * @return {*}
     */
    deleteIdentity(id) {
      this.$confirm('确认要删除么', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const [err, res] = await identityResourceApi.callDelete(id)

          if (!err) {
            this.$message.success({
              showClose: true,
              message: '删除成功',
            })
            this.searchList()
          }
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: 'info',
            message: '已取消删除',
          })
        })
    },
  },
  activated() {
    this.$nextTick(() => {
      this.$refs.eltable.doLayout()
    })
  },
  created() {
    this.searchList()
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
</style>
